window.heroAnimation = function() {

  $('[data-animate="hero"]').addClass('shape--animated');

  setTimeout(() => {

    $('[data-animate="hero-title-up"]').addClass('fadeInLeft animated');

  }, 1100);

  setTimeout(() => {

    $('[data-animate="hero-title"]').addClass('fadeInLeft animated');

  }, 1500);

}

$(document).ready(() => {

  if(!$('[data-animate="hero"]').hasClass('lazybg')) {

    window.heroAnimation();

  }

});